import { useEffect, useState } from 'react';
import axios from 'axios';
import { FileCheck } from 'lucide-react';
import '../styles/StudentProfile.css';
import '../styles/AdminDashboard.css';

export default function AdminTermsModal() {
    const [termsStatus, setTermsStatus] = useState({
        privacy_policy_accepted: false,
        terms_accepted: false,
        age_of_majority_confirmed: false
    });
    const [loadingTermsStatus, setLoadingTermsStatus] = useState(true);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/profile/terms`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        })
        .then(response => {
            setTermsStatus(response.data);
            setLoadingTermsStatus(false);
        })
        .catch(error => {
            console.error("Error fetching terms status (admin):", error);
            setLoadingTermsStatus(false);
        });
    }, []);

    const handleTermsChange = async (field, value) => {
        // prevent unchecking once accepted
        if (!value && termsStatus[field]) {
            return;
        }
        if (!value) {
            return;
        }

        const newStatus = { ...termsStatus, [field]: value };
        setTermsStatus(newStatus);

        try {
            await axios.put(
                `${process.env.REACT_APP_API_URL}/profile/terms`,
                { [field]: value },
                { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
            );
        } catch (error) {
            console.error("Error updating terms acceptance (admin):", error);
            setTermsStatus(termsStatus);
        }
    };

    const allAccepted =
        termsStatus.privacy_policy_accepted &&
        termsStatus.terms_accepted &&
        termsStatus.age_of_majority_confirmed;

    if (loadingTermsStatus || allAccepted) {
        return null;
    }

    return (
        <div className="lecturer-terms-backdrop">
            <div className="lecturer-terms-modal">
                <div className="consent-notice-header">
                    <FileCheck size={28} />
                    <div className="consent-notice-main">
                        <p className="consent-notice-title">Potwierdź wymagane zgody</p>
                        <p className="consent-notice-text">
                            Aby kontynuować korzystanie z systemu, zaakceptuj regulamin, politykę prywatności oraz potwierdź pełnoletniość.
                        </p>
                    </div>
                </div>
                <div className="consent-notice-checkboxes" style={{ marginTop: '1rem' }}>
                    <label className="consent-notice-checkbox">
                        <input
                            type="checkbox"
                            className="terms-checkbox"
                            checked={termsStatus.terms_accepted}
                            disabled={termsStatus.terms_accepted}
                            onChange={(e) => handleTermsChange('terms_accepted', e.target.checked)}
                        />
                        <span>Akceptuję Regulamin Systemu Arrio – PSDiA.</span>
                    </label>
                    <label className="consent-notice-checkbox">
                        <input
                            type="checkbox"
                            className="terms-checkbox"
                            checked={termsStatus.privacy_policy_accepted}
                            disabled={termsStatus.privacy_policy_accepted}
                            onChange={(e) => handleTermsChange('privacy_policy_accepted', e.target.checked)}
                        />
                        <span>Potwierdzam, że zapoznałem(am) się z Polityką prywatności Systemu Arrio – PSDiA.</span>
                    </label>
                    <label className="consent-notice-checkbox">
                        <input
                            type="checkbox"
                            className="terms-checkbox"
                            checked={termsStatus.age_of_majority_confirmed}
                            disabled={termsStatus.age_of_majority_confirmed}
                            onChange={(e) => handleTermsChange('age_of_majority_confirmed', e.target.checked)}
                        />
                        <span>Oświadczam, że mam ukończone 18 lat.</span>
                    </label>
                </div>
                <p className="consent-notice-text" style={{ marginTop: '1rem' }}>
                    Szczegółowe informacje znajdziesz w 
                    <a href="/system-regulations" target="_blank" style={{ color: '#92400e', fontWeight: 'bold', textDecoration: 'none' }}> Regulaminie Systemu Arrio – PSDiA</a> oraz w 
                    <a href="/privacy-policy" target="_blank" style={{ color: '#92400e', fontWeight: 'bold', textDecoration: 'none' }}> Polityce prywatności</a>.
                </p>
            </div>
        </div>
    );
}


